const FiltroStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Compila i seguenti campi",
                id: "filtroForm",
                description: "Filtri",
                multipleValue: false,
                rows : [
                {
                    id : "row1",
                    fields : [
                        {
                            name: "protocolNumber",
                            type: "text",
                            numColMd: 4,
                            label: "Identificativo",
                            tooltipText: "",
                            required: false,
                        },
                        {
                            name: "demacoProtocolNumber",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Protocollo Consob",
                            required: false,    
                        },
                        {
                            name: "reportingSubject",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Soggetto Segnalante",
                            required: false,    
                        },
                    ]
                },
                {
                    id : "row2",
                    fields : [
                        {
                            name: "startDate",
                            type: "date",
                            numColMd: 4,
                            label: "Data di Inizio",
                            tooltipText: "",
                            required: false,
                        },
                        {
                            name: "endDate",
                            type: "date",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Data di Fine",
                            required: false,    
                        },
                        {
                            name: "type",
                            type: "choice",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Tipo Segnalazione",
                            required: false,    
                        },
                    ]
                },
                {
                    id : "row3",
                    fields : [
                        {
                            name: "financialIntrumentCode",
                            type: "text",
                            numColMd: 4,
                            label: "Strumento Finanziario",
                            tooltipText: "",
                            required: false,
                        },
                        {
                            name: "suspicionType",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Tipologia Abuso",
                            required: false,    
                        },
                        {
                            name: "state",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Stato",
                            required: false,    
                        }
                    ]
                },
                {
                    id : "row4",
                    fields : [
                        {
                            name: "nomeLoi",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Line Of Inquiry",
                            required: false,    
                        },
                        {
                            name: "livello",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Livello",
                            required: false,    
                        },
                        {
                            name: "score",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Score",
                            required: false,    
                        }
                    ]
                },
                {
                    id : "row5",
                    fields : [
                        {
                            name: "nameOrSurnameReportedSubject",
                            type: "text",
                            numColMd: 4,
                            tooltipText: "",
                            label: "Nome del Soggetto Segnalato",
                            required: false,    
                        },
                    ]
                }]
            }  
        }
    }
}

export default FiltroStructure;